import styled from "styled-components"

const StyledItem = styled.figure`
  display: flex;
  flex-direction: "row";
  justify-content: flex-start;
  align-items: center;
  line-height: 40px;
  img {
    width: 36px;
    height: 100%;
    object-fit: contain;
  }
  figcaption {
    margin-left: 5px;
  }
`

export default StyledItem
